import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input, ElementRef, AfterViewInit, inject, ChangeDetectorRef } from '@angular/core';
import { ColumnLayoutRegistry } from '../../../core/services/ColumnLayoutRegistry';
import { IColumnPickerItem } from '../../../core/utils/column-layout';

@Component({
    selector: 'app-table-header',
    templateUrl: './table-header.component.html',
    styleUrls: ['./table-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TableHeaderComponent implements OnInit, AfterViewInit {

  @Input() loading = false;
  @Input() withExportOption = false;
  @Input() withClearCache = false;
  @Input() withColumnReset = true;

  @Output() reload = new EventEmitter<void>();
  @Output() exportBtnClicked = new EventEmitter<void>();
  @Output() clearCache = new EventEmitter<void>();

  public columnTableId: string | null = null;
  public columnOptions: IColumnPickerItem[] = [];

  private readonly el = inject(ElementRef);
  private readonly columnLayout = inject(ColumnLayoutRegistry);
  private readonly cdr = inject(ChangeDetectorRef);

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const parent = this.el.nativeElement.parentElement;
    this.columnTableId = parent?.querySelector('nz-table[id]')?.getAttribute('id') || null;
    this.cdr.markForCheck();
  }

  get showColumnReset(): boolean {
    return this.withColumnReset && !!this.columnTableId;
  }

  get showColumnPicker(): boolean {
    return !!this.columnTableId;
  }

  get lastHideableVisible(): boolean {
    return this.columnOptions.filter(col => !col.locked && col.visible).length <= 1;
  }

  onColumnMenuVisible(open: boolean): void {
    if (!open || !this.columnTableId) {
      return;
    }
    this.columnOptions = this.columnLayout.listColumns(this.columnTableId);
    this.cdr.markForCheck();
  }

  toggleColumn(key: string, visible: boolean): void {
    if (!this.columnTableId) {
      return;
    }
    this.columnLayout.setColumnVisible(this.columnTableId, key, visible);
    this.columnOptions = this.columnLayout.listColumns(this.columnTableId);
    this.cdr.markForCheck();
  }

  resetColumns(): void {
    if (this.columnTableId) {
      this.columnLayout.reset(this.columnTableId);
      this.columnOptions = this.columnLayout.listColumns(this.columnTableId);
    }
  }

}
